import { ListviewControllingComponent } from './listview-controlling.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule, LayoutModule } from 'sp-office365-layout';
import { AngularFrameworkModule } from 'sp-office365-framework';

const routes = [
    {
        path: 'targetfigures',
        component: ListviewControllingComponent,
    },
];

@NgModule({
    declarations: [ListviewControllingComponent],
    imports: [
        RouterModule.forChild(routes),
        TranslateModule,
        FuseSharedModule,
        LayoutModule,
        AngularFrameworkModule
    ],
    exports: [ListviewControllingComponent],
})
export class ListviewControllingModule {}
